var initialQty = 1;
const qty_input = jQuery('#Quantity-product-template');

jQuery('.qtyPlus').on('click',function(e){
	e.preventDefault();
    let newQty = parseInt(qty_input.val()) + 1;
  	jQuery('#Quantity-product-template').val(newQty)
})

jQuery('.qtyMinus').on('click',function(e){
	e.preventDefault();
  	let newQty = parseInt(qty_input.val()) - 1;
  if(newQty <= 0){
  	newQty = 1;
  }
  	jQuery('#Quantity-product-template').val(newQty)
  
})

jQuery('#SingleOptionSelector-0').on('change',function(){
    setTimeout(function(){
      var priceHTML = jQuery('.price-item--regular').html();
      jQuery('.product-form__cart-submit span').append('  | '+priceHTML);
    }, 100);  
})
jQuery(".accordion_head").click(function () {
  if (jQuery('.accordion_body').is(':visible')) {
    jQuery(".accordion_body").slideUp(300);
    jQuery(".plusminus").text('+');
  }
  if (jQuery(this).next(".accordion_body").is(':visible')) {
    jQuery(this).next(".accordion_body").slideUp(300);
    jQuery(this).children(".plusminus").text('+');
  } else {
    jQuery(this).next(".accordion_body").slideDown(300);
    jQuery(this).children(".plusminus").text('-');
  }
});




jQuery(".mobile-menu").click(function(){
    jQuery(this).toggleClass('open');  
	jQuery(".main-menu").slideToggle();  
});



jQuery('.slider-home').owlCarousel({
  loop: true,
  dots: true,
  // margin: 10,

  
  // navText: [
  //   "<i class='fa fa-caret-left'></i>",
  //   "<i class='fa fa-caret-right'></i>"
  // ],

 
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
      autoHeight: true
    },
    576: {
      items: 1,
      autoHeight: true
    },
    768: {
      items: 1,
      autoHeight: true
    },
    800: {
      items: 1,
      autoHeight: false
    },
    1000: {
      items: 1
    },
    1280: {
      items: 1
    }
  }
});


jQuery('.blog-post-slider').owlCarousel({
  loop: true,
  dots: true,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
      margin: 0,
    },
    576: {
      items: 2,
      margin: 10
    },
    768: {
      items: 3,
      margin: 0,
    },
    1280: {
      items: 5
    }
  }
});

jQuery('#opallac-using').owlCarousel({
  loop: true,
  dots: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2,
      margin: 10
    },
    680: {
      items: 3
    },
    800: {
      items: 4,
      margin: 20
    },
    1280: {
      items: 5
    },
    1440: {
      items: 8
    }
  }
});
jQuery('#opallac-social').owlCarousel({
  loop: true,
  dots: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2,
      margin: 10
    },
    680: {
      items: 3
    },
    800: {
      items: 4,
      margin: 20
    },
    1280: {
      items: 5
    },
    1440: {
      items: 8
    }
    
  }
});



jQuery('#opallac-collections .collections-wrp').owlCarousel({
  loop: true,
  dots: false,
  nav: false,
  margin: 20,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: true,
  navText: [
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-left.png?v=1622709544'>",
    "<img src='https://cdn.shopify.com/s/files/1/0550/5004/3588/files/arrow-right.png?v=1622709544'>"
  ],
  autoplay: true,
  autoplayTimeout:5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 2
    },
    800: {
      items: 3
    },
    1280: {
      items: 4
    }
  }
})



jQuery('.blog-details-bottom').owlCarousel({
  loop: true,
  dots: true,
  // margin: 10,

  
  // navText: [
  //   "<i class='fa fa-caret-left'></i>",
  //   "<i class='fa fa-caret-right'></i>"
  // ],

 
  // autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1
    },
    576: {
      items: 1
    },
    768: {
      items: 1
    },
    800: {
      items: 1
    },
    1000: {
      items: 1
    },
    1280: {
      items: 1
    }
  }
})


jQuery(window).scroll(function() {

if (jQuery(this).scrollTop() > 1){  
    jQuery('header').addClass("sticky");
  }
  else{
    jQuery('header').removeClass("sticky");
  }
  
});


 var winWidth = jQuery(window).width(); 

  var headWidth = jQuery(window).width();
  if (headWidth <= 991) {

      jQuery(".dropdownIcon").click(function () {
        jQuery(this).parent().toggleClass("open_sub");
      });

      console.log('jQuery 1234');

  }




$(".vpop").on('click', function(e) {
  e.preventDefault();
  $('#PageContainer').addClass('removeTransform');
  $("#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close").show();
  
  var srchref='',autoplay='',id=$(this).data('id');
  if($(this).data('type') == 'vimeo') var srchref="//player.vimeo.com/video/";
  else if($(this).data('type') == 'youtube') var srchref="https://www.youtube.com/embed/";
  
  if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
  
  $("#video-popup-iframe").attr('src', srchref+id+autoplay);
  
  $("#video-popup-iframe").on('load', function() {
    $("#video-popup-container").show();
  });
});

$("#video-popup-close, #video-popup-overlay").on('click', function(e) {
  $('#PageContainer').removeClass('removeTransform');
  $("#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay").hide();
  $("#video-popup-iframe").attr('src', '');
});


// jQuery(".vpop").on('click', function(e) {
//    e.preventDefault();
// 	jQuery(this).parent().parent().addClass('videoShow');
// });


 jQuery('.product-single__thumbnails-new').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.product-single__thumbnails'
});
jQuery('.product-single__thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-single__thumbnails-new',
  focusOnSelect: true,
  arrows: true,
  responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
});


    
jQuery(".accordion-items").click(function(){        
   jQuery(this).closest(".accordion-items").toggleClass("active").slow();
   jQuery(this).closest(".accordion-items").siblings().removeClass("active").slow();   
});

    
jQuery(".searchTab").on('click', function(e) {
	jQuery(".searchTabOpen").addClass('searchOpen');
    e.stopPropagation();
});
  
    
    

    jQuery('a[href="#search"]').on('click', function(event) {                    
    jQuery('#search').addClass('open');
    jQuery('#search > form > input[type="search"]').focus();
    });            
    jQuery('#search, #search .close').on('click keyup', function(event) {
    if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
    jQuery(this).removeClass('open');
    }
    });
    
jQuery('input[name="radio-group"]').on('click',function(){
    if(jQuery(this)[0].checked){
        jQuery('#donationForm input[name="id"]').val(jQuery(this).val())
    }
    
})    




jQuery('.inlineaddtocartform').on('submit',function(e){
  
  	e.preventDefault();
  	var current = $(this);
	var ID = $(this).find('input[name="id"]').val(); 
 	
  	current.find('.addtocartinline ').text('Adding...!')
    
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) {
       
	  $.ajax({
        type: 'GET',
        url: '/cart.js',
        
          
         success: function (cartData) {
			let raw_data = cartData
			let d = JSON.parse(raw_data)
           
         	$('.cart-Update').html(d.item_count)
           document.dispatchEvent(new Event("cart:updated"));
         } 
       });
       
       
       
      current.find('.addtocartinline ').text('Added to cart!')
      setTimeout(function(){
      	current.find('.addtocartinline ').text('Add again')
      },1000)

     } 
   });
})